import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ISuggestedInsights } from "@gtmhub/insights";
import { RequestConfig } from "@webapp/core/abstracts/models/request-config.model";
import { BaseFacade } from "@webapp/core/abstracts/services/base-facade.service";
import { AutoInsights, AutoInsightsDTO } from "@webapp/data-story/models/auto-insights-facade.models";
import { AutoInsightsApiService } from "@webapp/data-story/services/auto-insights-facade/auto-insights-api.service";
import { AutoInsightsState } from "@webapp/data-story/services/auto-insights-facade/auto-insights-state.service";

@Injectable()
export class AutoInsightsFacade extends BaseFacade<AutoInsights, AutoInsightsDTO, AutoInsightsState, AutoInsightsApiService> {
  constructor(state: AutoInsightsState, api: AutoInsightsApiService) {
    super(state, api);
  }

  public getInsightRecommendations$(title: string, { fromAccount = false }): Observable<ISuggestedInsights> {
    const url = fromAccount ? this.apiService.getAccountRecommendationsEndpoint() : this.apiService.getRecommendationsEndpoint();

    return this.get$<ISuggestedInsights>(null, {
      ...new RequestConfig(),
      queryParams: { kr: title },
      url: url,
    });
  }
}
